<template>
  <div class="custom-script-generator">
    <quill-editor
      v-model="content"
      ref="myQuillEditor"
      :options="editorOption"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
    >
    </quill-editor>
    <v-btn class="mt-5" @click="onSaveScript">Save script</v-btn>
  </div>
</template>


<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "CustomScriptGenerator",
  props: {
    agent_id: Number,
  },
  data() {
    return {
      content: "<h2>I am Example</h2>",
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
          ],
        },
      },
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),

    ...mapMutations({
      ADD_SCRIPT: "lead/ADD_SCRIPT",
    }),

    onEditorBlur(quill) {
      console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
    onSaveScript() {
      this.$axios
        .post(`/agents/scripts/create`, {
          agent_id: this.agent_id,
          type_id: 2,
          html: this.content,
        })
        .then((res) => {
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
          this.ADD_SCRIPT(res.data.script);
        })
        .catch((err) =>
          this.showHandlerSnackbar({
            color: err.response.data.status,
            text: err.response.data.message,
            show: true,
          })
        );
    },
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
};
</script>

<style>
</style>